import { useLocation } from 'react-router-dom';
import { useContext, useEffect } from 'react';
import { ZahtjevContext } from "../../common/context/ZahtjevProvider";

export function ScrollToTop() {
    const { setIsScrollToTop } = useContext(ZahtjevContext);
    const { pathname } = useLocation();

    useEffect(() => {
        if (pathname === "/redirect" || pathname === "/completed") {
            return;
        }
        setIsScrollToTop(false);
        const scrollAmount = window.innerHeight * 0.2;
        window.scrollTo({ top: scrollAmount, behavior: 'smooth' });

        const checkScrolling = setInterval(() => {
            if (window.scrollY >= scrollAmount - 20 && window.scrollY <= scrollAmount + 20) {
                setIsScrollToTop(true);
                clearInterval(checkScrolling);
            }
        }, 50);

        return () => clearInterval(checkScrolling);
    }, [pathname, setIsScrollToTop]);

    return null;
}
